import { render, staticRenderFns } from "./KYCQuestion.vue?vue&type=template&id=3ddccdc5"
import script from "./KYCQuestion.vue?vue&type=script&lang=js"
export * from "./KYCQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports